import { useMemo } from 'react'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { PollEntityType } from '@tribeplatform/gql-client/types'
import { useNetwork, usePost, useSpace } from '@tribeplatform/react-sdk/hooks'

export function usePollPermission({
  entityType,
  entityId,
}: {
  entityType?: PollEntityType
  entityId?: string
}) {
  const { data: post } = usePost({
    variables: {
      id: entityId,
    },
    useQueryOptions: {
      enabled: entityType === PollEntityType.Post,
    },
  })

  const { data: space } = useSpace({
    variables: {
      id: entityId,
    },
    useQueryOptions: {
      enabled: entityType === PollEntityType.Space,
    },
  })

  const { data: network } = useNetwork({
    useQueryOptions: {
      enabled: entityType === PollEntityType.Network,
    },
  })

  const [canCreateOrUpdate] = useMemo(() => {
    switch (entityType) {
      case PollEntityType.Post:
        return hasScopesPermission(post, ['updatePost'])
      case PollEntityType.Space:
        return hasScopesPermission(space, ['updateSpace'])
      case PollEntityType.Network:
        return hasScopesPermission(network, ['updateNetwork'])
      default:
        return [false]
    }
  }, [post, space, network, entityType])

  return {
    canCreateOrUpdate,
  }
}
